import { FunctionalComponent, h } from "@stencil/core";

interface GuidedTourProgressProps {
    step: number;
    total: number;
}

const baseClass: string = "ux-guided-tour-progress";

export const GuidedTourProgress: FunctionalComponent<GuidedTourProgressProps> = ({
    step = 0,
    total = 0,
}) => {
    const complete: number = total > 0 ? Math.min(1, step / total) : -1;
    return complete < 0 ? null : (
        <div class={baseClass}>
            <div
                class={`${baseClass}__bar`}
                style={{
                    width: `${complete * 100}%`,
                }}
            />
        </div>
    );
};
